import type { HTMLAttributes } from 'react';

import React from 'react';

import { TableBody } from './table-body/table-body';
import { ActionTableCell } from './table-cell/action-table-cell';
import { TableCell } from './table-cell/table-cell';
import { TableHeader } from './table-header/table-header';
import { TableHeaderCell } from './table-header-cell/table-header-cell';
import { TableRow } from './table-row/table-row';
import { classNames } from '../../utils/class-names';

import styles from './table.module.css';

export type TableProps = HTMLAttributes<HTMLTableElement>;

export function Table({ className, ...props }: TableProps) {
  return <table className={classNames(className, styles.table)} {...props} />;
}

Table.Header = TableHeader;
Table.Row = TableRow;
Table.HeaderCell = TableHeaderCell;
Table.Body = TableBody;
Table.Cell = TableCell;
Table.ActionCell = ActionTableCell;
